var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Renderer2 } from '@angular/core';
import { GameHostComponent } from '../game-host/game-host.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageType } from '../shared/model/message-type';
import { GameStatus } from '../shared/model/game-status';
import { SpinnerService } from '../shared/services/spinner.service';
import { WindowsService } from '../shared/services/windows.service';
var PageLiarsDiceHostComponent = /** @class */ (function (_super) {
    __extends(PageLiarsDiceHostComponent, _super);
    function PageLiarsDiceHostComponent(socketService, cookieService, router, resolver, renderer, spinnerService, windowService) {
        var _this = _super.call(this, socketService, cookieService, router, resolver, renderer, spinnerService, windowService) || this;
        _this.gamePrefix = 'L';
        _this.gameHasStarted = false;
        return _this;
    }
    PageLiarsDiceHostComponent.prototype.hostMessageHandler = function (message) {
        if (message.action === MessageType.Host) {
            this.connectedUsers = Object.values(message.content.users);
            this.avatarWidth = "calc(" + Math.floor(100 / this.connectedUsers.length) + "% - 20px)";
            if (message.content.status === GameStatus.Waiting) {
                this.gameId = message.content.id;
                this.cookieService.set('gameId', this.gameId, 1, '/');
            }
            else if (message.content.status === GameStatus.Complete) {
                this.gameIsOver = true;
                this.winner = Object.keys(message.content.dice)[0];
                console.log('Game is Complete!');
            }
            else if (message.content.status === GameStatus.InProgress) {
                this.setGameState(message);
            }
        }
    };
    PageLiarsDiceHostComponent.prototype.responseHandler = function (message) {
        console.log(message);
        if (message.action === MessageType.Prompt &&
            message.content.status === GameStatus.InProgress) {
            this.setGameState(message);
        }
    };
    PageLiarsDiceHostComponent.prototype.setGameState = function (message) {
        console.log('Set the game state!');
        this.gameHasStarted = true;
        this.currentSubmitter = message.content.currentSubmission.user;
        this.currentSubmission = message.content.currentSubmission;
        this.waitingPlayerSubmitterName = message.content.submitter;
        this.connectedUsers = Object.values(message.content.users);
    };
    return PageLiarsDiceHostComponent;
}(GameHostComponent));
export { PageLiarsDiceHostComponent };
